import React from 'react';
import { motion } from 'framer-motion';
import { Check, BookOpen } from 'lucide-react';
const modules = [{
  num: 1,
  title: 'Ingeniería de Informes OS',
  desc: 'El sistema exacto para redactar informes que IOMA, PAMI y OSDE aprueban sin cuestionar.',
  items: ['Plantillas listas para Inicio, Evolución, Cierre e Interdisciplinario', 'Checklist de 15 puntos pre-entrega', 'Tabla comparativa por Obra Social', 'Modelo de nota de reclamo por rechazo', 'Diccionario de sustitución urgente']
}, {
  num: 2,
  title: 'Bitácora de Campo Pro',
  desc: 'De "el paciente jugó" a registro clínico profesional real.',
  items: ['El Método OCI de 4 niveles de observación', 'Plantilla de registro diario lista para imprimir', 'Técnica de Descripción Neutra (TDN)', 'El Triángulo ACE para documentar intervenciones', 'Cómo organizar tu carpeta de paciente']
}, {
  num: 3,
  title: 'Matriz de Objetivos SMART',
  desc: 'Cómo transformar "el paciente mejoró" en metas medibles que justifican la continuidad del tratamiento.',
  items: ['30 objetivos SMART pre-armados por área', 'Plan de trabajo trimestral completo', '3 escalas de medición simples para AT', 'Cómo presentar objetivos ante el equipo interdisciplinario']
}, {
  num: 4,
  title: 'Manual de Crisis e Incidentes',
  desc: 'El protocolo legal y clínico para actuar y documentar cuando las cosas se complican.',
  items: ['Los 7 tipos de crisis más frecuentes', 'Protocolo de intervención en 5 pasos', 'Plantilla de reporte de incidente', 'Protocolo de comunicación de emergencias', '3 casos reales resueltos y documentados']
}, {
  num: 5,
  title: 'Arsenal de Intervención',
  desc: '+100 actividades terapéuticas listas para usar, organizadas por área clínica y diagnóstico.',
  items: ['Árbol de decisión rápida por estado del paciente', 'Actividades para TEA, TDAH, Psicosis, Gerontes y Niños', 'Guía de adaptación universal por patología', 'Planificador semanal de sesiones']
}, {
  num: 6,
  title: 'Psicopatología para Informes',
  desc: 'El diccionario técnico que te permite escribir con autoridad clínica sin asumir el rol del psicólogo.',
  items: ['Guías de términos para TEA, Psicosis, TLP, DI y Gerontes', 'Códigos CIE-10 más usados en AT', 'Tabla maestra de sustitución coloquial-clínico', 'Frases tipo listas para cada tipo de informe']
}, {
  num: 7,
  title: 'Ética y Encuadre de Hierro',
  desc: 'Cómo proteger tu rol profesional y poner límites sin perder el trabajo.',
  items: ['Los 5 límites no negociables del AT profesional', 'Respuestas exactas para las situaciones más incómodas con la familia', 'Modelo de acuerdo de trabajo con la familia', '5 casos éticos reales resueltos']
}, {
  num: 8,
  title: 'Banco de Frases Pro',
  desc: '+100 frases técnicas listas para copiar, adaptar y usar en cualquier informe.',
  items: ['Frases para inicio, evolución, avances, crisis y cierre', 'Frases específicas para TEA, Psicosis, TLP y Gerontes', 'Conectores clínicos para darle fluidez al informe', 'Tabla maestra de sustitución rápida coloquial-técnico']
}];
export function ModulesSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-129">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-130">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-131">
          LOS 8 MÓDULOS PROFESIONALES
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-132" />
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-133">
        {modules.map((mod, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-[#0f1d36] border border-[#1a2b4c] rounded-2xl p-6 md:p-8 hover:border-[#d4af37]/40 transition-colors flex flex-col h-full" data-id="element-134">
            <div className="flex items-start gap-4 mb-4" data-id="element-135">
              <div className="bg-[#0a1628] p-3 rounded-xl border border-[#d4af37]/20 shrink-0" data-id="element-136">
                <BookOpen className="w-6 h-6 text-[#d4af37]" data-id="element-137" />
              </div>
              <div data-id="element-138">
                <div className="text-[#d4af37] text-sm font-bold tracking-widest mb-1" data-id="element-139">
                  MÓDULO {mod.num}
                </div>
                <h3 className="text-xl font-bold text-white font-heading leading-tight" data-id="element-140">
                  {mod.title}
                </h3>
              </div>
            </div>

            <p className="text-[#a0aec0] mb-6 italic" data-id="element-141">{mod.desc}</p>

            <ul className="space-y-3 mt-auto" data-id="element-142">
              {mod.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-143">
                  <Check className="w-5 h-5 text-green-400 shrink-0 mt-0.5" data-id="element-144" />
                  <span className="text-[#e2e8f0] text-sm md:text-base" data-id="element-145">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>)}
      </div>
    </section>;
}